import { BASEURL, IMGBASEURL } from "@/config/index";
const ImageS3BaseURL = process.env.VUE_IMG_S3_BASE_URL
  ? process.env.VUE_IMG_S3_BASE_URL
  : BASEURL
  ? BASEURL
  : "https://img-dev.brij.tech/";
export default {
  imageBaseURL: BASEURL,
  imageS3BaseURL: ImageS3BaseURL,

  movieImages: {
    moviesUploadThumbnailImage: "280*350"
  },
  dateFormat: "dd MMM yyyy",
  cookiekeys: {
    BRHSID: "BRHSID"
  }
};



// WEBPACK FOOTER //
// ./src/helper/constant.js